import axios from "axios";
import config from '../../config.js';
const LogoutRequestHandler = (isManualLogout = false) => {
    const SystemUrl = config.SystemUrl;
    axios.post(SystemUrl + "logout").catch(() => {}).finally(function (){
        var lang = localStorage.getItem('lang') || "en";
        var styleUrl = localStorage.getItem('styleUrl') || "/assets/css/main-modular.css"

        localStorage.clear();
        localStorage.setItem('lang',lang)
        localStorage.setItem('styleUrl',styleUrl)
        
        if (isManualLogout === true) {
            localStorage.setItem('is_redirect_dashboard', "true");
        } else {
            // It's an automatic session timeout, track exactly where they were
            // We ignore root or login paths to avoid looping incorrectly
            const currentPath = window.location.pathname + window.location.search;
            if (currentPath !== '/' && currentPath !== '/login') {
                localStorage.setItem('exact_recovery_route', currentPath);
            }
        }
        
        window.location.href = "/";
    });
}
export default LogoutRequestHandler;